<template>
    <div>
        <div class="loading" v-if="loading">
            <van-loading size="0.64rem" color="var(--grey)" />
        </div>
        <div class="header">
            <van-notice-bar
                color="var(--primary)"
                background="#d2f1f0"
                left-icon="info-o"
            >{{noticeText}}</van-notice-bar>
        </div>
        <div class="report-user-info">
            <van-row class="report-row">
                <van-col span="24">
                    <div>报告名称: {{reportDetail.reportName}}</div>
                </van-col>
            </van-row>
            <van-row class="report-row">
                <van-col span="8">
                    <div>姓名: {{reportDetail.patName}}</div>
                </van-col>
                <van-col span="8">
                    <div>性别: {{reportDetail.patGender}}</div>
                </van-col>
                <van-col span="8">
                    <div>年龄: {{reportDetail.patAge}}</div>
                </van-col>
            </van-row>
            <van-row class="report-row">
                <van-col span="16">
                    <div>开单科室: {{reportDetail.depName}}</div>
                </van-col>
                <van-col span="8">
                    <div>开单医生: {{reportDetail.docName}}</div>
                </van-col>
            </van-row>
            <van-row class="report-row">
                <van-col span="16">
                    <div>检验标本: {{reportDetail.specimen}}</div>
                </van-col>
                <van-col span="8">
                    <div>报告医生: {{reportDetail.reportDocName}}</div>
                </van-col>
            </van-row>
            <van-row class="report-row">
                <van-col span="16">
                    <div>报告时间: {{reportDetail.reportTime }}</div>
                </van-col>
                <van-col span="8">
                    <div>报告录入: {{reportDetail.reportEntryName}}</div>
                </van-col>
            </van-row>
        </div>
        <div class="report-detail-info">
            <van-sticky>
                <van-row class="report-title">
                    <van-col span="9">
                        <div>项目</div>
                    </van-col>
                    <van-col span="5">
                        <div>结果</div>
                    </van-col>
                    <van-col span="4">
                        <div>单位</div>
                    </van-col>
                    <van-col span="6">
                        <div>参考值</div>
                    </van-col>
                </van-row>
            </van-sticky>
            <van-row class="report-content" v-for="(item, index) in reportDetail.detailList" :key="index">
                <van-col span="10">
                    <div>{{item.id}} {{item.name || '-'}}</div>
                </van-col>
                <van-col span="4">
                    <div>{{item.result || '-'}}<van-icon v-if="item.high" name="down" color="red" style="transform: rotate(180deg)" /><van-icon v-if="item.low" name="down" color="blue" />
                </div>
                </van-col>
                <van-col span="4">
                    <div>{{item.unit || '-'}}</div>
                </van-col>
                <van-col span="6">
                    <div>{{item.scope || '-'}}</div>
                </van-col>
            </van-row>
        </div>
    </div>
</template>

<script>
import manageApi from '@/api/manageApi';

export default {
    data() {
        return {
            loading: false,
            schedLoading: false,
            reportDetail: {
                reportName: '血液细胞检验报告单',
                patName: '李治',
                patGender: '男',
                patAge: '25',
                depName: '门诊',
                docName: '刘睿',
                specimen: '静脉血',
                reportDocName: '刘睿',
                reportTime: '2024-06-03 08:44',
                reportEntryName: '刘睿',
                detailList: [
                    {id: 1, name: '白细胞(WBC)', result: '10.55', scope: '3.50-9.50', unit: '10ˆ9L', high: true, low: false},
                    {id: 2, name: '中性粒细胞比例(Neu%)', result: '88.7', scope: '40.0-75.0', unit: '%', high:true, low: false},
                    {id: 3, name: '淋巴细胞比例(Lym%)', result: '6.2', scope: '20.0-50.0', unit: '%',high: false, low: true},
                    {id: 4, name: '单核细胞比例(Hor%)', result: '3.8', scope: '3.0-10.0', unit: '%',high: false, low: false},
                    {id: 5, name: '嗜酸性粒细胞比例(Eos%)', result: '0.7', scope: '0.4-8.0', unit: '%',high: false, low: false},
                    {id: 6, name: '嗜碱性粒细胞比例(Bas%)', result: '0.6', scope: '0.0-1.0', unit: '%',high: false, low: false},
                    {id: 7, name: '中性粒细胞绝对值(Neu#)', result: '9.37', scope: '1.80-6.30', unit: '10ˆ9L', high: true, low: false},
                    {id: 8, name: '淋巴细胞绝对值(Lym#)', result: '0.65', scope: '1.10-3.20', unit: '10ˆ9L',high: false, low: true},
                    {id: 9, name: '单核细胞绝对值(Mon#)', result: '0.40', scope: '0.10-0.60', unit: '10ˆ9L', high: false, low: false},
                    {id: 10, name: '嗜酸性粒细胞绝对值(Eos#)', result: '0.07', scope: '0.02-0.52', unit: '10ˆ9L', high: false, low: false},
                    {id: 11, name: '嗜碱性粒细胞绝对值(Bas#)', result: '0.06', scope: '0.00-0.06', unit: '10ˆ9L', high: false, low: false},
                    {id: 12, name: '*异常淋巴细胞数目(ALY#)', result: '0.00', scope: '0.00-0.20', unit: '10ˆ9L', high: false, low: false},
                    {id: 13, name: '*异常淋巴细胞百分比(ALY%)', result: '0.0', scope: '0.0-2.0', unit: '%', high: false, low: false},
                    {id: 14, name: '*巨大未成熟细胞数目(LIC#)', result: '0.05', scope: '0.00-0.20', unit: '10ˆ9L',high: false, low: false},
                    {id: 15, name: '*巨大未成熟细胞百分比(LIC%)', result: '0.5', scope: '0.0-2.5', unit: '%',high: false, low: false},
                    {id: 16, name: '红细胞 (RBC)', result: '3.93', scope: '3.80-5.10', unit: '10ˆ12L',high: false, low: false},
                    {id: 17, name: '血红蛋白(HGB)', result: '112', scope: '115-150', unit: 'g/L',high: false, low: true},
                    {id: 18, name: '红细胞压积(HCT)', result: '31.5', scope: '35.0-45.0', unit: '%',high: false, low: true},
                    {id: 19, name: '红细胞平均体积(MCV)', result: '80.2', scope: '82.0-100.0', unit: 'fL',high: false, low: true},
                    {id: 20, name: '平均血红蛋白含量(MCH)', result: '28.6', scope: '27.0-34. 0', unit: 'pg',high: false, low: false},
                    {id: 21, name: '平均血红蛋白浓度(MCHC)', result: '357', scope: '316-354', unit: 'g/L',high: true, low: false},
                    {id: 22, name: '红细胞变异系数(RDW-CV)', result: '13.1', scope: '11.0-16.0', unit: '%',high: false, low: false},
                    {id: 23, name: '分布宽度标准差(RDW-SD)', result: '44.0', scope: '35.0-56.0', unit: 'fL',high: false, low: false},
                    {id: 24, name: '血小板(PLT)', result: '306', scope: '125-350', unit: '10ˆ9L',high: false, low: false},
                    {id: 25, name: '血小板平均体积(MPV)', result: '10.2', scope: '6.5-12.0', unit: 'fL',high: false, low: false},
                    {id: 26, name: '血小板分布宽度(PDW)', result: '16.3', scope: '9.0-17.0', unit: 'fL',high: false, low: false},
                    {id: 27, name: '血小板压积(PCT)', result: '0.310', scope: '0. 108-0.282', unit: '%',high: true, low: false},
                ]
            },
            noticeText: '此检验报告仅供参考，不作为任何医学凭据，请以医院最终的报告单数据为准。若对检验结果有任何疑问，请直接到医院进行查询打印，检验结果临床意义请咨询相关医生！',
        };
    },
    created() {
        
    },
    methods: {
        
    },
    props: {
        id: {
            type: String,
            required: false
        }
    }
}
</script>


<style lang="less" scoped>
.loading {
    text-align: center;
}
.report-user-info {
    font-size: 0.35rem;
    margin-top: -0.13rem;
    background-color: var(--white);
}

.report-user-info .report-row {
    margin: 0.13rem 0.41rem 0rem 0.41rem;
    padding: 0.27rem 0rem;
    border-bottom: 0.01rem solid rgba(0, 0, 0, 0.1);
}

.report-user-info .report-row:last-child {
    border: none;
}

.report-detail-info .report-title {
    font-size: 0.3rem;
    padding: 0.27rem 0.41rem;
    background-color: var(--bg);
}

.report-detail-info .report-content {
    font-size: 0.3rem;
    background-color: var(--white);
    color: var(--grey);
    padding: 0.27rem 0.41rem;
    border-bottom: 0.01rem solid rgba(0, 0, 0, 0.1);
    line-height: 0.4rem;
}

.report-detail-info .report-content:last-child {
    border: none;
}

.report-detail-info .report-content div {
    padding: 0rem 0.1rem;
}

.signNormal {
    background-color: var(--white) !important;
    color: var(--grey) !important;
}

.signHigh {
    background-color: #fadbd9 !important;
    color: var(--black) !important;
}

.signLow {
    background-color: #FFFBE5 !important;
    color: var(--black) !important;
}
</style>